// REACT AND REACT HOOKS
import React, { useEffect, useState } from 'react';

// BOOTSTRAP COMPONENTS
import { Modal, Button } from 'react-bootstrap';

// FONT AWESOME FOR ICONS
import 'font-awesome/css/font-awesome.min.css';

// DATATABLES LIBRARY
import DataTable from 'datatables.net-react';

// TABLE COLUMN CONFIGURATIONS (reuse real columns)
import { columnsTransactions } from '../FP_foodPantryTables';

// INTRO.JS FOR TOUR
import introJs from 'intro.js';

export function FakeItemDetailsModal({ show, onHide, foodPantryTourStager, setFoodPantryTourStager }) {
    // Example static data for demo
    const fakeItemName = "Red Apples";
    const fakeUnitQty = "3 lb";
    const fakePackSize = "Bag";
    const fakeQty = 303;

    const variationTotals = [
        {
            variationName: "Equate Red Apples",
            qty: 0,
            unitPrice: "$6.56",
            totalValue: "$0.00",
            upc: "912660818894",
            plu: "",
            otherCode: ""
        },
        {
            variationName: "Signature Select Red Apples",
            qty: 95,
            unitPrice: "$1.53",
            totalValue: "$145.35",
            upc: "865922238202",
            plu: "",
            otherCode: ""
        },
        {
            variationName: "Oral-B Red Apples",
            qty: 98,
            unitPrice: "$3.52",
            totalValue: "$344.96",
            upc: "127150564610",
            plu: "",
            otherCode: ""
        }
    ];

    const columnsVariationTotals = [
        {
            title: "Variation",
            data: "variationName",
            render: function (data, type, row) {
                return `<span style="color: #3A57E8;">${data}</span>`;
            }
        },
        { title: "Total Qty", data: "qty" },
        { title: "Avg Unit Price", data: "unitPrice" },
        { title: "Total Value", data: "totalValue" },
        {
            title: "Code (UPC / PLU / AltID)",
            data: null,
            render: function (data, type, row) {
                if (row.upc && row.upc !== "") return row.upc;
                if (row.plu && row.plu !== "") return row.plu;
                if (row.otherCode && row.otherCode !== "") return row.otherCode;
                return "";
            }
        }
    ];

    const fakeTransactions = [
        {
            transactionID: 1,
            itemName: fakeItemName,
            variationName: "Equate Red Apples",
            transactionQty: 10,
            transactionValue: "$65.60",
            totalTransactionValue: "$65.60",
            averageValue: "$6.56",
            unitValue: "$6.56",
            transactionDate: "2025-10-01"
        },
        {
            transactionID: 2,
            itemName: fakeItemName,
            variationName: "Signature Select Red Apples",
            transactionQty: 20,
            transactionValue: "$30.60",
            totalTransactionValue: "$30.60",
            averageValue: "$1.53",
            unitValue: "$1.53",
            transactionDate: "2025-10-02"
        },
        {
            transactionID: 3,
            itemName: fakeItemName,
            variationName: "Oral-B Red Apples",
            transactionQty: 15,
            transactionValue: "$52.80",
            totalTransactionValue: "$52.80",
            averageValue: "$3.52",
            unitValue: "$3.52",
            transactionDate: "2025-10-03"
        }
    ];

    // State for showing fake modals
    const [showFakeEditItemModal, setShowFakeEditItemModal] = useState(false);
    const [showFakeVariationModal, setShowFakeVariationModal] = useState(false);
    const [variationTourStarted, setVariationTourStarted] = useState(false);
    const [editItemTourStarted, setEditItemTourStarted] = useState(false);
    const [mainTourCompleted, setMainTourCompleted] = useState(false);
    const [tourStep, setTourStep] = useState(0); // Replace the mainTourCompleted logic with a stepper for clarity

    // 1. Start the variations table tour
    useEffect(() => {
        if (
            show &&
            foodPantryTourStager === "Item Details" &&
            tourStep === 0
        ) {
            const interval = setInterval(() => {
                const variationsTable = document.getElementById('variations-table');
                const firstCell = document.getElementById('variation-row-0-col-0');
                if (variationsTable && firstCell) {
                    clearInterval(interval);
                    // Prevent starting if a tour is already running
                    if (document.querySelector('.introjs-overlay')) return;
                    const intro = introJs();
                    intro.setOptions({
                        steps: [
                            {
                                element: '#variations-table',
                                intro: 'This table shows all variations of the item.',
                                hidePrev: true
                            },
                            {
                                element: '#variation-row-0-col-0',
                                intro: "To edit a specific variation, click the variation's name.",
                                hidePrev: true
                            }
                        ],
                        showBullets: false,
                        exitOnOverlayClick: false
                    });
                    intro.onbeforechange(function () {
                        // Hide back button (redundant with hidePrev: true, but ensure it's hidden)
                        setTimeout(() => {
                            const backBtn = document.querySelector('.introjs-prevbutton');
                            if (backBtn) backBtn.style.display = 'none';
                            // Force next/done button to say Next
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.innerText = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.innerText = 'Next';
                        }, 0);
                    });
                    setTimeout(() => {
                        intro.refresh();
                        intro.start();
                    }, 200);
                    intro.oncomplete(() => {
                        setShowFakeVariationModal(true);
                        setTourStep(1);
                    });
                }
            }, 150);
            return () => clearInterval(interval);
        }
    }, [show, foodPantryTourStager, tourStep]);

    // 2. Variation modal tour
    useEffect(() => {
        if (showFakeVariationModal && tourStep === 1) {
            const timeout = setTimeout(() => {
                const codeSwitcher = document.getElementById('variation-code-switcher');
                const inputFields = document.getElementById('variation-input-fields');
                const saveBtn = document.getElementById('variation-save-btn');
                if (codeSwitcher && inputFields && saveBtn) {
                    // Prevent starting if a tour is already running
                    if (document.querySelector('.introjs-overlay')) return;
                    const intro = introJs();
                    intro.setOptions({
                        steps: [
                            {
                                element: '#variation-code-switcher',
                                intro: 'Select which Code Type you want the variation to use.',
                                hidePrev: true
                            },
                            {
                                element: '#variation-input-fields',
                                intro: "Change the variation's details here using these input fields.",
                                hidePrev: true
                            },
                            {
                                element: '#variation-save-btn',
                                intro: 'To save your changes, click this button.',
                                hidePrev: true
                            }
                        ],
                        showBullets: false,
                        exitOnOverlayClick: false
                    });
                    intro.onbeforechange(function () {
                        setTimeout(() => {
                            const backBtn = document.querySelector('.introjs-prevbutton');
                            if (backBtn) backBtn.style.display = 'none';
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.innerText = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.innerText = 'Next';
                        }, 0);
                    });
                    setTimeout(() => {
                        intro.refresh();
                        intro.start();
                    }, 200);
                    intro.oncomplete(() => {
                        setShowFakeVariationModal(false);
                        setTourStep(2);
                    });
                }
            }, 200);

            return () => clearTimeout(timeout);
        }
    }, [showFakeVariationModal, tourStep]);

    // 3. Highlight Edit Item button and open Edit Item modal
    useEffect(() => {
        if (
            show &&
            foodPantryTourStager === "Item Details" &&
            !showFakeVariationModal &&
            !showFakeEditItemModal &&
            tourStep === 2
        ) {
            const interval = setInterval(() => {
                const editBtn = document.getElementById('edit-item-details-btn');
                if (editBtn) {
                    clearInterval(interval);
                    // Prevent starting if a tour is already running
                    if (document.querySelector('.introjs-overlay')) return;
                    const intro = introJs();
                    intro.setOptions({
                        steps: [
                            {
                                element: '#edit-item-details-btn',
                                intro: 'Click here to edit the item the variations are tied to.',
                                hidePrev: true
                            }
                        ],
                        showBullets: false,
                        exitOnOverlayClick: false
                    });
                    intro.onbeforechange(function () {
                        setTimeout(() => {
                            const backBtn = document.querySelector('.introjs-prevbutton');
                            if (backBtn) backBtn.style.display = 'none';
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.innerText = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.innerText = 'Next';
                        }, 0);
                    });
                    setTimeout(() => {
                        intro.refresh();
                        intro.start();
                    }, 200);
                    intro.oncomplete(() => {
                        setShowFakeEditItemModal(true);
                        setTourStep(3);
                    });
                }
            }, 150);
            return () => clearInterval(interval);
        }
    }, [show, foodPantryTourStager, showFakeVariationModal, showFakeEditItemModal, tourStep]);

    // 4. Edit Item Modal tour: highlight all input fields, then Save button
    useEffect(() => {
        if (showFakeEditItemModal && tourStep === 3) {
            const timeout = setTimeout(() => {
                const inputFields = document.getElementById('edit-item-fields-group');
                const saveBtn = document.getElementById('edit-item-save-btn');
                if (inputFields && saveBtn) {
                    // Prevent starting if a tour is already running
                    if (document.querySelector('.introjs-overlay')) return;
                    const intro = introJs();
                    intro.setOptions({
                        steps: [
                            {
                                element: '#edit-item-fields-group',
                                intro: 'Change the item details here using these input fields.',
                                hidePrev: true
                            },
                            {
                                element: '#edit-item-save-btn',
                                intro: 'Save your changes by clicking this button.',
                                hidePrev: true
                            }
                        ],
                        showBullets: false,
                        exitOnOverlayClick: false
                    });
                    intro.onbeforechange(function () {
                        setTimeout(() => {
                            const backBtn = document.querySelector('.introjs-prevbutton');
                            if (backBtn) backBtn.style.display = 'none';
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.innerText = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.innerText = 'Next';
                        }, 0);
                    });
                    setTimeout(() => {
                        intro.refresh();
                        intro.start();
                    }, 200);
                    intro.oncomplete(() => {
                        setShowFakeEditItemModal(false);
                        setTourStep(4);
                    });
                }
            }, 200);
            return () => clearTimeout(timeout);
        }
    }, [showFakeEditItemModal, tourStep]);

    // 5. After Edit Item modal, highlight transactions table and finish
    useEffect(() => {
        if (
            show &&
            foodPantryTourStager === "Item Details" &&
            !showFakeEditItemModal &&
            tourStep === 4
        ) {
            const interval = setInterval(() => {
                const transactionsTable = document.getElementById('transactions-table');
                if (transactionsTable) {
                    clearInterval(interval);
                    // Prevent starting if a tour is already running
                    if (document.querySelector('.introjs-overlay')) return;
                    const intro = introJs();
                    intro.setOptions({
                        steps: [
                            {
                                element: '#transactions-table',
                                intro: 'This table shows all the transactions of all variations tied to this item.',
                                hidePrev: true
                            }
                        ],
                        showBullets: false,
                        exitOnOverlayClick: false
                    });
                    intro.onbeforechange(function () {
                        setTimeout(() => {
                            const backBtn = document.querySelector('.introjs-prevbutton');
                            if (backBtn) backBtn.style.display = 'none';
                            const nextBtn = document.querySelector('.introjs-nextbutton');
                            if (nextBtn) nextBtn.innerText = 'Next';
                            const doneBtn = document.querySelector('.introjs-donebutton');
                            if (doneBtn) doneBtn.innerText = 'Next';
                        }, 0);
                    });
                    setTimeout(() => {
                        intro.refresh();
                        intro.start();
                    }, 200);
                    intro.oncomplete(() => {
                        setFoodPantryTourStager && setFoodPantryTourStager("complete");
                        setTourStep(0);
                        onHide();
                    });
                }
            }, 150);
            return () => clearInterval(interval);
        }
    }, [show, foodPantryTourStager, showFakeEditItemModal, tourStep, onHide, setFoodPantryTourStager]);

    return (
        <>
            {/* Hide the Item Details Modal when either edit modal is open */}
            <Modal
                show={
                    show &&
                    !showFakeEditItemModal &&
                    !showFakeVariationModal
                }
                onHide={onHide}
                size="xl"
                aria-labelledby="view item details"
                centered
            >
                <div className="text-dark">
                    <Modal.Header>
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div style={{ visibility: 'hidden' }}>
                                <Button variant="light" style={{ border: 'none', background: 'none' }}>
                                    <i className="fa-solid fa-arrow-left"></i>
                                </Button>
                            </div>
                            <Modal.Title className="text-center w-100">
                                <h5 className="ps-0 pt-2 pb-2">
                                    {fakeItemName} {fakeUnitQty} {fakePackSize}
                                    <span className="opacity-50"> ({fakeQty} OH)</span>
                                </h5>
                            </Modal.Title>
                            <Button variant="light" onClick={onHide}>
                                <i className="fa fa-times"></i>
                            </Button>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ps-2 pb-1"><h5>Variations</h5></div>
                        <div id="variations-table">
                            <DataTable
                                data={variationTotals}
                                columns={columnsVariationTotals}
                                options={{
                                    paging: false,
                                    scrollCollapse: true,
                                    scrollY: '200px',
                                    searching: false,
                                    ordering: true,
                                    responsive: true,
                                    dom: 'Bfrtp',
                                    language: {
                                        info: "_START_-_END_ of _TOTAL_ variations",
                                        infoEmpty: "No variation data available"
                                    },
                                    createdRow: function (row, data, dataIndex) {
                                        if (dataIndex === 0) {
                                            // Add id to first row, first column
                                            const firstCell = row.cells[0];
                                            if (firstCell) firstCell.id = "variation-row-0-col-0";
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div className="ps-2 py-1"><h5>Transactions</h5></div>
                        <div id="transactions-table">
                            <DataTable
                                data={fakeTransactions}
                                columns={columnsTransactions}
                                options={{
                                    paging: false,
                                    scrollCollapse: true,
                                    scrollY: '200px',
                                    searching: false,
                                    ordering: true,
                                    responsive: true,
                                    dom: 'Bfrtp',
                                    language: {
                                        info: "_START_-_END_ of _TOTAL_ transactions",
                                        infoEmpty: "No transaction data available"
                                    }
                                }}
                            />
                        </div>
                        <div className="d-flex gap-2 justify-content-end mt-3">
                            <button
                                id="edit-item-details-btn"
                                className='btn btn-primary'
                                onClick={() => setShowFakeEditItemModal(true)}
                            >
                                Edit Item Details
                            </button>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>

            {/* Fake Edit Item Modal */}
            <Modal
                show={showFakeEditItemModal}
                onHide={() => setShowFakeEditItemModal(false)}
                size="lg"
                centered
            >
                <Modal.Header>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <Button
                            variant="light"
                            onClick={() => setShowFakeEditItemModal(false)}
                        >
                            <i className="fa fa-arrow-left"></i>
                        </Button>
                        <Modal.Title className="text-center flex-grow-1">
                            <h5 className="mb-0">
                                Red Apples 3 lb Bag
                            </h5>
                        </Modal.Title>
                        <Button
                            variant="light"
                            onClick={() => setShowFakeEditItemModal(false)}
                        >
                            <i className="fa fa-times"></i>
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="pt-3">
                            <h5>Edit Item Details</h5>
                        </div>
                        <form className="mt-3">
                            <div id="edit-item-fields-group">
                                <div className="row g-2">
                                    <div className="col-md-6 form-floating">
                                        <input
                                            type="text"
                                            className="form-control my-1"
                                            value="Red Apples"
                                            placeholder='Item Name'
                                            readOnly
                                        />
                                        <label className="form-label">
                                            Item Name
                                        </label>
                                    </div>
                                    <div className="col-md-6 form-floating">
                                        <input
                                            type="text"
                                            className="form-control my-1"
                                            value="Fruit"
                                            placeholder='Category'
                                            readOnly
                                        />
                                        <label className="form-label">
                                            Category
                                        </label>
                                    </div>
                                </div>
                                <div className="row g-2">
                                    <div className="col-md-4 form-floating">
                                        <input
                                            name="suggestedPrice"
                                            placeholder="Price"
                                            className="form-control my-1"
                                            value="$2.99"
                                            readOnly
                                        />
                                        <label className="form-label">
                                            Price
                                        </label>
                                    </div>
                                    <div className="col-md-4 form-floating">
                                        <div className="input-group">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Size"
                                                    className="my-1 form-control"
                                                    name="unit"
                                                    value="3"
                                                    readOnly
                                                />
                                                <label className="form-label">
                                                    Size
                                                </label>
                                            </div>
                                            <select
                                                className="form-select"
                                                value="lb"
                                                disabled
                                            >
                                                <option value="lb">lb</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4 form-floating">
                                        <input
                                            type="number"
                                            className="form-control my-1"
                                            value="1"
                                            placeholder='Pack'
                                            readOnly
                                        />
                                        <label className="form-label">
                                            Pack
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    type="button"
                                    variant="primary"
                                    id="edit-item-save-btn"

                                >
                                    Save Changes
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Fake Edit Variation Modal */}
            <Modal
                show={showFakeVariationModal}
                onHide={() => setShowFakeVariationModal(false)}
                size="lg"
                centered
            >
                <Modal.Header>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        {/* Back Button */}
                        <Button
                            variant="light"
                            onClick={() => setShowFakeVariationModal(false)}
                        >
                            <i className="fa fa-arrow-left"></i>
                        </Button>
                        <div className="d-flex justify-content-center w-100">
                            <h5 className="mb-0">
                                Equate Red Apples <span className="ms-2">3 lb</span>
                            </h5>
                        </div>
                        <Button
                            variant="light"
                            onClick={() => setShowFakeVariationModal(false)}
                        >
                            <i className="fa fa-times"></i>
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body id="fake-variation-modal">
                    <div className="d-flex align-items-center mb-2">
                        <h5 className="mb-0 me-3">Edit Variation Details</h5>
                        {/* Triple selector for code type */}
                        <div className="triple-selector" id="variation-code-switcher">
                            <div className="switch">
                                <input
                                    id="switch-upc-edit"
                                    name="variationCodeTypeEdit"
                                    type="radio"
                                    value="upc"
                                    className="switch-input"
                                    checked
                                    readOnly
                                />
                                <label htmlFor="switch-upc-edit" className="switch-label switch-label-y">UPC</label>
                                <input
                                    id="switch-plu-edit"
                                    name="variationCodeTypeEdit"
                                    type="radio"
                                    value="plu"
                                    className="switch-input"
                                    readOnly
                                />
                                <label htmlFor="switch-plu-edit" className="switch-label switch-label-i">PLU</label>
                                <input
                                    id="switch-alt-edit"
                                    name="variationCodeTypeEdit"
                                    type="radio"
                                    value="otherCode"
                                    className="switch-input"
                                    readOnly
                                />
                                <label htmlFor="switch-alt-edit" className="switch-label switch-label-n">ALTID</label>
                                <span className="switch-selector"></span>
                            </div>
                        </div>
                    </div>
                    <form className="mt-3" id="variation-input-fields">
                        <div className="row g-2">
                            <div className="col-md-6 form-floating">
                                <input
                                    type="text"
                                    className="form-control my-1"
                                    placeholder='Variation Name'
                                    value="Equate Red Apples"
                                    readOnly
                                />
                                <label className="form-label">Variation Name</label>
                            </div>
                            <div className="col-md-6 form-floating">
                                <input
                                    type="text"
                                    className="form-control my-1"
                                    value="912660818894"
                                    placeholder='UPC Code'
                                    readOnly
                                />
                                <label className="form-label">Product Code</label>
                            </div>
                        </div>
                        <div className="row g-2">
                            <div className="col-md-6 form-floating">
                                <input
                                    type="text"
                                    className="form-control my-1"
                                    value="Red Apples"
                                    placeholder='Item Name'
                                    readOnly
                                />
                                <label className="form-label">Item Name</label>
                            </div>
                            <div className="col-md-6 form-floating">
                                <input
                                    type="text"
                                    className="form-control my-1"
                                    value="$6.56"
                                    placeholder="Suggested Price"
                                    readOnly
                                />
                                <label className="form-label">Suggested Price</label>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                type="button"
                                variant="primary"
                                id="variation-save-btn"

                            >
                                Save Changes
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}